import React from 'react';
import './TransactionHistory.css';
import { useWeb3ModalAccount } from '@web3modal/ethers/react';
import { useEffect, useState } from 'react';
import { formatUnits } from 'ethers';
import Modal from '../Modal';

const TransactionHistory = ({ vContract }) => {

  const {address, isConnected} = useWeb3ModalAccount();
  const [tx, setTx] = useState([]);

  useEffect(() =>{
    if(isConnected) {
      getData();
    }
  }, [vContract])

  const getData = async() => {
    try {
      const result = await vContract.getUserDeposits(address);
      setTx(result);
    } catch (error) {
      console.log(error)
    }
  }

  const formatUnixTimestamp = (unixTimestamp) => {
    const date = new Date(unixTimestamp * 1000); // Convert seconds to milliseconds
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  };

  const truncateAddress = (addr) => {
    return `${addr.slice(0,6)}...${addr.slice(-4)}`;
  };

  return (
    <section className="transaction-history">
      <h2>Transaction History</h2>
      <div className="table-container">
        <table className="transaction-table">
          <thead>
            <tr>
              <th>Address</th>
              <th>Stage</th>
              <th>Tokens Amount</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {tx.map((tx, index) => (
              <tr key={index}>
                <td>
                  <span className="wallet-address">
                    {truncateAddress(address)}
                  </span>
                </td>
                <td>
                  <span className="stage-badge">
                    Stage {Number(tx[0]) + 1}
                  </span>
                </td>
                <td>
                  <span className="token-amount">
                    {Number(formatUnits(tx[1])).toFixed(2)}
                  </span>
                </td>
                <td>
                  <span className="transaction-date">
                    {formatUnixTimestamp(Number(tx[2]))}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default TransactionHistory;
